module.exports = __webpack_public_path__ + "portal/assets/img/logo.828af0ca.svg";